// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"bddec73e","453":"b3181a33"}[chunkId] + ".chunk.js";
};